<template>
	<module class="module-config" title="时间轴配置">
		<c-form ref="form" vertical unit-width="100%">
			<c-form-item label="模块名称" required>
				<c-input v-model="title" name="title"></c-input>
			</c-form-item>
			<c-form-item ref="list" name="list" label="时间轴内容" required>
				<c-grid-row v-if="dataList.length" column="2" gap>
					<c-grid-col v-for="(item, i) in dataList" :key="i" class="group">
						<div class="group-index">{{i + 1}}</div>
						<div class="group-handle flex">
							<a v-if="i > 0" class="flex-center" @click="sortHandle(i, -1)"><i class="tf-sort-up"></i></a>
							<a v-if="i < dataList.length - 1" class="flex-center" @click="sortHandle(i, 1)"><i class="tf-sort-down"></i></a>
							<a class="flex-center" @click="dataList.splice(i, 1)"><i class="tf-cross"></i></a>
						</div>
						<c-form ref="itemForm" unit-width="100%">
							<c-form-item label="时间节点" required>
								<c-input v-model="item.name" name="name" placeholder="例：2026年8月（最多12个字）" maxlength="12"></c-input>
							</c-form-item>
							<c-form-item label="介绍内容" required>
								<c-input v-model="item.content" type="textarea" name="content" maxlength="500"></c-input>
							</c-form-item>
						</c-form>
					</c-grid-col>
				</c-grid-row>
				<div class="group-add flex-center" @click="pushHandle()"><i class="tf-add"></i>添加节点</div>
			</c-form-item>
		</c-form>
	</module>
</template>

<script>
	export default {
		data() {
			return {
				title: '',
				dataList: []
			}
		},

		methods: {
			pushHandle() {
				this.dataList.push({
					name: '',
					content: ''
				});
				this.$refs.list.warn(false);
			},

			sortHandle(index, dir) {
				this.dataList.splice(index + dir, 0, this.dataList.splice(index, 1)[0]);
			},

			setConfig(config = {}) {
				if (config.data) {
					this.title = config.data.title || '';
					if (config.data.list.length) {
						this.dataList = config.data.list;
					}
				}
			},

			getConfig() {
				return new Promise(resolve => {
					Promise.all([
						new Promise(resolve => {
							this.$refs.form.validate({
								rule: {
									title: '请填写模块名称',
									list: [{
										type: 'function',
										message: '请添加时间轴内容',
										fun: () => {
											return this.dataList.length > 0;
										}
									}]
								},
								success: () => {
									resolve(true);
								},
								fail: () => {
									resolve(false);
								}
							});
						})
					].concat((this.$refs.itemForm || []).map($form => {
						return new Promise(resolve => {
							$form.validate({
								rule: {
									name: '请填写时间节点',
									content: '请填写介绍内容'
								},
								success: () => {
									resolve(true);
								},
								fail: () => {
									resolve(false);
								}
							});
						})
					}))).then(data => {
						if (data.findIndex(item => item === false) == -1) {
							resolve({
								type: 6,
								data: {
									title: this.title,
									list: this.dataList
								}
							});
						} else {
							resolve(false);
						}
					})
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.group {
		position: relative;
		border-radius: 6px;
		padding: 22px 26px 16px 16px;
		background: #F9F9F9;

		&-index {
			position: absolute;
			left: 0;
			top: 0;
			width: 18px;
			border-radius: 6px 0 6px 0;
			line-height: 18px;
			font-size: 12px;
			text-align: center;
			color: #0081FA;
			background: #E0EDF9;
		}

		&-handle {
			position: absolute;
			right: 0;
			top: 0;
			border-radius: 0 6px 0 6px;
			overflow: hidden;
			background: #eee;

			a {
				width: 18px;
				height: 18px;
				font-size: 12px;
				color: #aaa;

				&:hover {
					color: var(--color-main);
				}

				&:nth-last-child(1) {
					color: #fff;
					background: #f55;
				}
			}
		}

		&-add {
			gap: 6px;
			height: 38px;
			border: 1px dashed var(--color-main);
			border-radius: 6px;
			font-size: 14px;
			color: var(--color-main);
			cursor: pointer;

			&:hover {
				border-color: var(--color-main-hover);
				color: var(--color-main-hover);
			}

			&:nth-child(n+2) {
				margin-top: 10px;
			}
		}
	}

	.color-list {
		gap: 8px;
		padding: 2px 0;

		li {
			box-sizing: border-box;
			width: 34px;
			height: 34px;
			border: 1px solid #fff;
			border-radius: 100%;
			cursor: pointer;

			&:hover,
			&.z-crt {
				border-color: var(--color-main);
			}

			div {
				width: 22px;
				height: 22px;
				border: 1px solid #ddd;
				border-radius: 100%;
			}
		}
	}

	>>> .data-filter .filter li:nth-child(1):nth-last-child(1) {
		padding-top: 4px;
	}
</style>